import React from 'react';

import Info from '../f-Utilities/Info'

function IssuesGeneral(props){
    let territory = props.territory;
    return(
      <div className="row">
        <div className="col">
          <div className="row mb-2">
            <div className="col-auto">
              <h3 className="line">enjeux</h3>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p><span className="key_figure red-text">{territory.issues.ghg_emissions_total.toLocaleString("fr-FR")} tCO2</span>eq/an émissions de GES (gaz à effet de serre)
              <Info content="La stratégie nationale bas-carbone française (SNBC) s’est fixée comme objectif une diminution de 28 % des émissions de la mobilité en 2030 par rapport à 2015."/></p>
              <p>→ <b>{Math.round(territory.issues.ghg_emissions_total/territory.all_travels.total_pop*10)/10}</b> tCO2eq/hab/an</p>
              <p className="mt-3"><span className="key_figure red-text">{Math.round(territory.issues.fuel_cost_total/territory.all_travels.total_hh)} €</span> /mois budget carburant moyen par ménage</p>
            </div>
          </div>
        </div>
      </div>

  );
}

export default IssuesGeneral;
